import React from 'react'

import { TicketType } from '@/types/TicketType'

type Props = {
  ticketType: TicketType
}

const MobileTicketTypeCard = ({ ticketType }: Props) => {
  return (
    <div className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md">
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Ticket Type ID</p>
        <p className="ml-3 flex-1 text-right text-sm" style={{ fontWeight: 'bold' }}>
          {ticketType.id}
        </p>
      </div>
      <div className="flex justify-between">
        <p className="flex-none text-sm text-grey-500">Description</p>
        <p className="ml-3 flex-1 text-right text-sm">{ticketType.description}</p>
      </div>
    </div>
  )
}
export default MobileTicketTypeCard
